module.exports = __webpack_public_path__ + "static/media/calender.b43b7c52.svg";